import "./App.scss";

import {
  Link,
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import "react-inner-image-zoom/lib/InnerImageZoom/styles.css";
import React, { Suspense, useEffect, useRef, useState } from "react";
import { lazy } from "react";
import Header from "./b2b/header/Header";
import Footer, { isValidEmail } from "./b2b/Footer/Footer";

import Favorites from "./b2b/Pages/Favorites/Favorites";
import { Bounce, toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoginSignup from "./auth/LoginSignup";
import {
  useCheckPaymentStatusMutation,
  useGetCouponListQuery,
  useGetCustomerBagDataQuery,
  useGetCustomerWishlistQuery,
  useGetHeaderLabelsDataQuery,
  useGetHomeDataQuery,
  useSubscribeMutation,
} from "./redux/slices/homeSlice";
import { setWishlist } from "./redux/slices/wishlistSlice";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useDispatch, useSelector } from "react-redux";
import Category from "./b2b/Pages/Category/Category";
import {
  addToMyBag,
  setMyBag,
  setOrderDetails,
} from "./redux/slices/myBagSlice";
import MyBag from "./b2b/Pages/MyBag/MyBag";
import ShoppingBag from "./b2b/Pages/ShoppingBag/ShoppingBag.jsx";
import ShoppingTray from "./b2b/Pages/ShoppingTray/ShoppingTray.jsx";
import OrderPlaced from "./b2b/Pages/OrderPlaced/OrderPlaced.jsx";
import ProfileDetails from "./b2b/Pages/ProfileDetails/ProfileDetails.jsx";
import BTN from "./b2b/Master/BTN.jsx";
import INPUT from "./b2b/Master/INPUT.jsx";
import Sidebar from "./b2b/header/Sidebar.jsx";
import TrackOrder from "./b2b/Pages/ProfileDetails/TrackOrder.jsx";
import ExchangeOrder from "./b2b/Pages/ProfileDetails/ExchangeOrder.jsx";
import CancelOrder from "./b2b/Pages/ProfileDetails/CancelOrder.jsx";
import ReturnOrder from "./b2b/Pages/ProfileDetails/ReturnOrder.jsx";
import ContactUs from "./b2b/Pages/ContactUs/ContactUs.jsx";
import "react-loading-skeleton/dist/skeleton.css";
import AboutUs from "./b2b/Pages/BrandInfo/AboutUs.jsx";
import PrivacyPolicy from "./b2b/Pages/BrandInfo/PrivacyPolicy.jsx";
import TermsCondition from "./b2b/Pages/BrandInfo/TermsCondition.jsx";
import ExchangePolicy from "./b2b/Pages/BrandInfo/ExchangePolicy.jsx";
import ReturnPolicy from "./b2b/Pages/BrandInfo/ReturnPolicy.jsx";
import OrderFailed from "./b2b/Pages/OrderPlaced/OrderFailed.jsx";
import { COMING_SOON_BANNER, PAGE_NOT_FOUND } from "./assets/index.js";
import Skeleton from "react-loading-skeleton";
import { useFormik } from "formik";
import FlipClockCountdown from "@leenguyen/react-flip-clock-countdown";
import "@leenguyen/react-flip-clock-countdown/dist/index.css";
import { Breakpoint } from "react-socks";
import DagaHome from "./b2b/home/DagaHome.js";
import DagaProductPage from "./b2b/Pages/DagaProductPage/DagaProductPage.jsx";
import DagaBlogCard from "./b2b/Pages/DagaBlogPage/DagaBlogCard.jsx";
import DagaBlogPage from "./b2b/Pages/DagaBlogPage/DagaBlogPage.jsx";
function App() {
  const location = useLocation();
  const [sidebarToggle, setSidebarToggle] = useState(false);
  // lens screen steps
  const [lensStep, setLensStep] = useState(1);
  const dispatch = useDispatch();
  const user = localStorage.getItem("user");

  const {
    data: homeData,
    isSuccess: homeDataIsSuccess,
    isLoading: homeDataIsLoading,
    isError: homeDataIsError,
    error: homeDataError,
  } = useGetHomeDataQuery();

  useEffect(() => {
    scrollToTop();
  }, [location.pathname]);
  const {
    data: headerLabelsData,
    isSuccess: headerLabelsSuccess,
    isLoading: headerLabelsLoading,
    isError: headerLabelsIsError,
    error: headerLabelsError,
  } = useGetHeaderLabelsDataQuery();
  const navigate = useNavigate();
  const {
    data: wishlistData,
    isSuccess: wishlistSuccess,
    isLoading: wishlistLoading,
    isError: wishlistIsError,
    error: wishlistError,
  } = useGetCustomerWishlistQuery({ user: user }, { skip: !user });
  
  useEffect(() => {
    if (wishlistError?.status === 401) {
      localStorage.removeItem("user");
      navigate("/");
    }
  }, [wishlistData, user]);

  useEffect(() => {
    if (wishlistSuccess) {
      const data = wishlistData.wishlist;
      dispatch(setWishlist(data));
    } else if (wishlistIsError) {
      dispatch(setWishlist([]));
    }
  }, [wishlistData, wishlistSuccess, wishlistIsError]);

  const {
    data: customerBagData,
    isSuccess: customerBagIsSuccess,
    isLoading: customerBagIsLoading,
    isError: customerBagIsError,
    error: customerBagError,
  } = useGetCustomerBagDataQuery({ user: user }, { skip: !user });

  const {
    data: couponData,
    isSuccess: couponDataIsSuccess,
    isLoading: couponDataIsLoading,
    isError: couponDataIsError,
    error: couponDataError,
  } = useGetCouponListQuery({ user: user, couponType: "" }, { skip: !user });

  const calculateCartTotalWithoutOffer = () => {
    return customerBagData?.cart?.reduce((total, item) => {
      return total + item?.prices?.originalPrice * item?.quantity;
    }, 0);
  };

  useEffect(() => {
    if (customerBagIsSuccess) {
      const data = customerBagData.cart;
      dispatch(setMyBag(data));
    } else if (customerBagError && user !== null) {
      dispatch(setMyBag([]));
    }
  }, [customerBagData, customerBagIsSuccess, customerBagIsError, couponData]);

  const [isRetailerPage, setIsRetailerPage] = useState(false);

  useEffect(() => {
    setIsRetailerPage(false);
  }, [location.pathname]);

  const eyeFramesRef = useRef(null);
  const newArrivalsRef = useRef(null);
  const ourStoreRef = useRef(null);
  const contactUsRef = useRef(null);

  // ===================== CLEAR WISHLIST AND CART ON LOGOUT ===================

  // useEffect(() => {
  //   if (!user) {
  //     dispatch(setMyBag([]));
  //     dispatch(setWishlist([]));
  //   }
  // }, [user]);

  // user subscribe email

  const [subscribe] = useSubscribeMutation();
  const subscribeFormik = useFormik({
    initialValues: {
      email: "",
    },
    onSubmit: async function (values) {
      subscribe({
        body: {
          email: values?.email,
        },
      }).then((res) => {
        if (res?.data) {
          subscribeFormik?.resetForm();
          toast.success(res?.data.message);
        } else {
          console.log(res);
          toast.error(`${res?.error?.data?.message}`);
        }
      });
    },
    validate: (values) => {
      let errors = {};
      if (!values?.email) {
        errors.email = "Email id is Required!";
      } else if (!isValidEmail(values?.email)) {
        errors.email = "Email is not valid!";
      }
      return errors;
    },
  });

  return (
    <div
    // className={`App ${
    //   location.pathname.includes("retailer") &&
    //   location.pathname !== "/become-retailer"
    //     ? "pt-[68px]"
    //     : "lg:pt-[140px] emd:pt-[70px] small:pt-[70px]"
    // } `}
    >
      {/* {location.pathname.includes("retailer") &&
      location.pathname !== "/become-retailer" ? (
        <RetailerHeader
          eyeFramesRef={eyeFramesRef}
          newArrivalsRef={newArrivalsRef}
          ourStoreRef={ourStoreRef}
          contactUsRef={contactUsRef}
        />
      ) : (
        <Header
          isRetailerPage={isRetailerPage}
          sidebarToggle={sidebarToggle}
          setSidebarToggle={setSidebarToggle}
          headerLabelsData={headerLabelsData}
        />
      )} */}
      <Header
        isRetailerPage={isRetailerPage}
        sidebarToggle={sidebarToggle}
        setSidebarToggle={setSidebarToggle}
        headerLabelsData={headerLabelsData}
      />
      {/* {isRetailerPage ? (
        <RetailerHeader />
      ) : (
        <Header
          isRetailerPage={isRetailerPage}
          sidebarToggle={sidebarToggle}
          setSidebarToggle={setSidebarToggle}
          headerLabelsData={headerLabelsData}
        />
      )} */}
      {/* <Header
          sidebarToggle={sidebarToggle}
          setSidebarToggle={setSidebarToggle}
          headerLabelsData={headerLabelsData}
        /> */}
      <MyBag setLensStep={setLensStep} />
      <Sidebar
        sidebarToggle={sidebarToggle}
        setSidebarToggle={setSidebarToggle}
        headerLabelsData={headerLabelsData}
      />
      <Routes>
        <Route
          exact
          path="/"
          element={
            <>
              {/* <Home /> */}
              <DagaHome homeData={homeData} />
            </>
          }
        />
        <Route
          path="/search/:searchProductParams?"
          element={
            <>
              <Suspense fallback={<div>Loading...</div>}>
                <Category />
              </Suspense>
            </>
          }
        />
        {/* <Route
          exact
          path="/:retailer"
          element={
            <>
              <Retailer setIsRetailerPage={setIsRetailerPage} />
            </>
          }
        /> */}
        {/* <Route
          exact
          path="/retailer/:retailerName"
          element={
            <>
              <Retailer
                setIsRetailerPage={setIsRetailerPage}
                eyeFramesRef={eyeFramesRef}
                newArrivalsRef={newArrivalsRef}
                ourStoreRef={ourStoreRef}
                contactUsRef={contactUsRef}
              />
            </>
          }
        /> */}
        <Route
          exact
          path="/products/:id"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <DagaProductPage />
            </Suspense>
          }
        />
        <Route
          exact
          path="/blog"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <DagaBlogCard />
            </Suspense>
          }
        />
        <Route
          exact
          path="/blog/:name"
          // path="/blog/post"
          element={
            <Suspense fallback={<div>Loading...</div>}>
              <DagaBlogPage />
            </Suspense>
          }
        />
        <Route
          path="/categories/:name"
          element={
            <>
              <Suspense fallback={<div>Loading...</div>}>
                <Category />
              </Suspense>
            </>
          }
        />

        <Route
          path="/favourites"
          element={
            <>
              <Favorites />
            </>
          }
        />
        <Route
          path="/shopping-bag"
          element={<ShoppingBag setLensStep={setLensStep} />}
        />
        <Route path="/shopping-tray" element={<ShoppingTray />} />
        <Route path="/profile-details" element={<ProfileDetails />} />
        <Route
          path="/track-order/:trackOrderId/:trackProductSku"
          element={<TrackOrder />}
        />
        <Route
          path="/cancel-order/:cancelOrderId/:cancelProductId"
          element={<CancelOrder />}
        />
        <Route path="/order-check/:orderId" element={<OrderCheck />} />
        <Route path="/order-placed/:orderId" element={<OrderPlaced />} />
        <Route path="/order-failed/:orderId" element={<OrderFailed />} />
        <Route
          path="/exchange-order/:exchangeOrderId/:exchangeProductId/:exchangeProductSku"
          element={<ExchangeOrder />}
        />
        <Route
          path="/return-order/:returnOrderId/:returnProductId/:returnProductSku"
          element={<ReturnOrder />}
        />
        <Route
          path="/shopping-tray/confirm"
          element={
            <>
              <div className="">Confirmation page</div>
            </>
          }
        />

        <Route path="/login" element={<LoginSignup />} />
        <Route path="/signup" element={<LoginSignup />} />
        <Route path="/contact-us" element={<ContactUs />} />
        {/* <Route path="/become-retailer" element={<BecomeRetailer />} /> */}
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/return-policy" element={<ReturnPolicy />} />
        <Route path="/exchange-policy" element={<ExchangePolicy />} />
        <Route path="/terms-condition" element={<TermsCondition />} />

        <Route path="*" element={<PageNotFound />} />
      </Routes>
      {/* {location.pathname !== "/become-retailer" &&
      location.pathname.includes("retailer") ? null : (
        <Footer />
      )} */}
      <Footer />

      <ToastContainer
        position="top-center"
        autoClose={500}
        theme="dark"
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={true}
        draggable={true}
        progress={undefined}
        transition={Bounce}
        toastStyle={{
          opacity: 0.9,
        }}
      />
    </div>
  );
}

export default App;

function scrollToTop() {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "instant",
  });
  // scrooll .App to top
  const scrollArea = document.querySelector(".App");
  if (!scrollArea) return;
  scrollArea.scrollTo({
    top: 0,
    left: 0,
    behavior: "instant",
  });
}

export const PageNotFound = () => {
  return (
    <Link
      to="/"
      style={{
        width: "100%",
        height: "70vh",
        objectFit: "contain",
        display: "block",
      }}
    >
      <img
        style={{
          height: "100%",
          width: "100%",
          verticalAlign: "middle",
          objectFit: "contain",
        }}
        src={PAGE_NOT_FOUND}
        alt="PAGE NOT FOUND"
      />
    </Link>
  );
};

const OrderCheck = () => {
  const { orderId } = useParams();
  const [checkPaymentStatus] = useCheckPaymentStatusMutation();
  const navigate = useNavigate();
  useEffect(() => {
    if (orderId) {
      console.log(orderId);
      const body = {
        order_id: orderId,
      };
      checkPaymentStatus({ body: body })
        .then((res) => {
          if (res.data.status == "Placed") {
            navigate(`/order-placed/${orderId}`);
          } else {
            navigate(`/order-failed/${orderId}`);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [orderId]);

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        zIndex: 9999999,
        width: "100vw",
        maxWidth: "100%",
        height: "100dvh",
        overflow: "hidden",
      }}
    >
      <Skeleton height={"100%"} />
      <div className="absolute top-[50%] left-[50%] -translate-x-1/2 -translate-y-1/2">
        <p>
          Please do not go back or refresh the page. Your payment is being
          processed...
        </p>
      </div>
    </div>
  );
};
